// Types para comprobantes recibidos
export const RECEIVED_VOUCHERS_REQUEST = 'RECEIVED_VOUCHERS_REQUEST';
export const RECEIVED_VOUCHERS_SUCCESS = 'RECEIVED_VOUCHERS_SUCCESS';
export const RECEIVED_VOUCHERS_ERROR   = 'RECEIVED_VOUCHERS_ERROR';
export const RECEIVED_VOUCHERS_CLEAR   = 'RECEIVED_VOUCHERS_CLEAR';
